import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { KTIcon, toAbsoluteUrl } from '../../../helpers';
import {
	HeaderNotificationsMenu,
	HeaderUserMenu,
	Search,
	ThemeModeSwitcher,
} from '../../../partials';
import request from '../../../../utils/request';
import { IdentifyType, TNotificationPayload, TNotifTable } from "../../../../constants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../global/store";
import moment from "moment";
import enAU from "date-fns/locale/en-AU";

const itemClass = 'ms-1 ms-md-4';
const btnClass =
	'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px';
const userAvatarClass = 'symbol-35px';
const btnIconClass = 'fs-2';
const REACT_APP_DEVELOPMENT = process.env.REACT_APP_DEVELOPMENT;

moment.locale('en', enAU);

const Navbar = () => {
	const customerNumber = localStorage.getItem('customerNum') || null;
	const userID = localStorage.getItem('userId') || null;
	const dispatch = useDispatch();

	const identify: IdentifyType = useSelector(
		(v: RootState) => v.customerReducer.identify
	);

	const [menuTrigger, setMenuTrigger] = useState<string | undefined>(undefined);
	const [subscriptionNotif, setSubscriptionNotif] = useState([]);
	const [serviceRequestNotif, setServiceRequestNotif] = useState([]);
	const [amendmentNotif, setAmendmentNotif] = useState([]);
	const [promotNotif, setPromoNotif] = useState([]);

	const [updatedLastSeen, setUpdatedLastSeen] = useState<TNotificationPayload | null>(null);
	const [notificationCount, setNotificationCount] = useState(0);
	const [notificationRes, setNotificationRes] = useState<TNotifTable>();
	const [tabSelected, setTabSelected] = useState('');
	const [tabReadStatus, setTabReadStatus] = useState({
		subscription: false,
		serviceRequest: false,
		amendment: false,
		promo: false,
	});


	const fetchData = async () => {
		try {
			const response = await request.post(
				'/Notifikasi/GetNotifTableIndex',
				{
					draw: 0,
					start: '0',
					length: 5,
					search: {
						value: localStorage.getItem('customerNum') || '',
						regex: true,
					},
					advSearch: {
						areaCode: identify?.area_code,
						notifikasiLastSeen: JSON.stringify(identify?.notifikasiLastSeen)
					}
				}
			);


			if (response.status === 200 || response.status === 201) {
				const data = response.data.data
				setNotificationRes(data);
				setSubscriptionNotif(data.subscription)
				setServiceRequestNotif(data.permintaanLayanan)
				setAmendmentNotif(data.amandemen)
				setPromoNotif(data.promo)

				const totalNotifications =
					data.promoToReadCount + data.permintaanLayananToReadCount + data.amandemenToReadCount + data.subscriptionToReadCount;

				setNotificationCount(totalNotifications);
			}
		} catch (error) {
			console.error('Error fetching notifications:', error);
		}
	};
	const handleUpdateNotif = async () => {
		let menu = '';

		switch (tabSelected) {
			case '#kt_topbar_notifications_1':
				menu = 'subscription';
				if (!tabReadStatus.subscription) {
					setNotificationCount(notificationCount - (notificationRes?.subscriptionToReadCount || 0));
					setTabReadStatus({ ...tabReadStatus, subscription: true });
				} else {
					setSubscriptionNotif([])
				}
				break;
			case '#kt_topbar_notifications_2':
				menu = 'serviceRequest';
				if (!tabReadStatus.serviceRequest) {
					setNotificationCount(notificationCount - (notificationRes?.permintaanLayananToReadCount || 0));
					setTabReadStatus({ ...tabReadStatus, serviceRequest: true });
				} else {
					setServiceRequestNotif([])
				}
				break;
			case '#kt_topbar_notifications_3':
				menu = 'amendment';
				if (!tabReadStatus.amendment) {
					setNotificationCount(notificationCount - (notificationRes?.amandemenToReadCount || 0));
					setTabReadStatus({ ...tabReadStatus, amendment: true });
				} else {
					setAmendmentNotif([])
				}
				break;
			case '#kt_topbar_notifications_4':
				menu = 'promo';
				if (!tabReadStatus.promo) {
					setNotificationCount(notificationCount - (notificationRes?.promoToReadCount || 0));
					setTabReadStatus({ ...tabReadStatus, promo: true });
				} else {
					setPromoNotif([])
				}
				break;
			default:
				break;
		}


		const payload: TNotificationPayload = {
			menu: {
				...updatedLastSeen!.menu,
				[`${menu}`]: moment().format('YYYY-MM-DD HH:mm:ss.SSS'),
			},
			customerNumber: customerNumber,
			userID: userID
		}

		console.info(payload)
		// return;

		await request.post(`/notifikasi/UpdateNotifikasiLastSeen`, payload)
			.then((res) => {
				if (res.status === 200 || res.status === 201) {
					setUpdatedLastSeen(JSON.parse(res.data.data.updatedLastSeen))
				}
			})
	}


	useEffect(() => {
		if ((identify?.area_code !== null && identify?.area_code !== '') || (identify?.notifikasiLastSeen?.userID !== null || identify?.notifikasiLastSeen?.customerNumber !== null)) {
			setMenuTrigger("{default: 'click'}")
			setUpdatedLastSeen(identify.notifikasiLastSeen)
			fetchData().then();
		}
	}, [identify]);


	useEffect(() => {
		if (tabSelected !== null && tabSelected !== '') {
			handleUpdateNotif().then()
		}
	}, [tabSelected]);

	return (
		<div className="app-navbar flex-shrink-0">
			{REACT_APP_DEVELOPMENT && REACT_APP_DEVELOPMENT == '1' && (<div className={clsx('app-navbar-item', itemClass)}>
				<div
					data-kt-menu-trigger="{default: 'click'}"
					data-kt-menu-attach="parent"
					data-kt-menu-placement="bottom-end"
					className={`${btnClass} position-relative pulse`}
					style={{ margin: '0 10px' }}
				>
					{!isNaN(notificationCount) && notificationCount > 0 ? <span
						style={{
							top: 0,
							right: 0,
							marginTop: '-5px',
							marginRight: '-5px',
							height: '14px',
							width: '14px',
							padding: '8px',
							fontSize: '8px',
						}}
						className="badge badge-circle badge-danger position-absolute"
					>
						{notificationCount}
					</span> : ''}

					<KTIcon
						iconName="bi bi-bell-fill"
						className={btnIconClass}
					/>

					{!isNaN(notificationCount) && notificationCount > 0 ? <span className="pulse-ring"></span> : ''}
				</div>
				<HeaderNotificationsMenu
					subscriptions={subscriptionNotif?.length ? subscriptionNotif : null}
					serviceRequests={serviceRequestNotif?.length ? serviceRequestNotif : null}
					amendments={amendmentNotif?.length ? amendmentNotif : null}
					promos={promotNotif?.length ? promotNotif : null}
					setTabSelected={setTabSelected}
					tabReadStatus={tabReadStatus}
					handleUpdateNotif={async () => await handleUpdateNotif()}
				/>
			</div>)}

			{/* <div className={clsx('app-navbar-item', itemClass)}>
				<ThemeModeSwitcher
					toggleBtnClass={clsx('btn-active-light-primary btn-custom')}
				/>
			</div> */}

			<div className={clsx('app-navbar-item', itemClass)}>
				<div
					className={clsx('cursor-pointer symbol', userAvatarClass)}
					data-kt-menu-trigger="{default: 'click'}"
					data-kt-menu-attach="parent"
					data-kt-menu-placement="bottom-end"
				>
					<img
						src={toAbsoluteUrl('/media/avatars/blank.png')}
						alt=""
					/>
				</div>
				<HeaderUserMenu />
			</div>
		</div>
	);
};

export { Navbar };
